import { Box } from '@mui/material';
import styled from 'styled-components';

export const DeleteIconContainer = styled(Box)`
  && {
    border-radius: ${({ theme }) => theme.shape.avatarRadius};
    background-color: ${({ theme }) => theme.palette.danger.light};
    width: 3.75rem;
    height: 3.75rem;
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      width: 1.75rem;
      height: 1.75rem;
      color: ${({ theme }) => theme.palette.danger.main};
    }
  }
`;
